import React, { Component } from 'react';
import { connect } from 'react-redux';
import FirstStep from './FirstStep';
import SecondStep from './SecondStep';
import ThirdStep from './ThirdStep';
import Modal from '../../../../../components/Modal';
import Steps from '../../../../../components/Steps';
import Loader from '../../../../../components/Loader';
import { searchPedidos, clearPedidosBuscar } from '../../../../../actions';
import Alert from '../../../../../components/Alert';

const nroPag=1;
const cantidadxPag=10000;
const vacio='';

class AsociarPedido extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      step: 1,
      numPedidosProforma:[],
      FirstStep: {
        pedidosSeleccionados: [],
        pedidoInput: '',
      },
      SecondStep: {
        init: true,
      },
      rowSelected:[],
      alertErrorOpenModFacturacion: false,
      alertErrorMessage:'',
      pedidosSeleccionadosOld:[]
    };
  }

  fnPedidosSeleccionadosOld = (pedidosSeleccionadosOld) => {
    this.setState({pedidosSeleccionadosOld:pedidosSeleccionadosOld})
  }

  componentDidMount() {

    this.fnNumPedidosProforma();


  }

  closeAlertErrorModFacturacion = () => this.setState({ alertErrorOpenModFacturacion: false });

  openAlertFacturacion = (data) => {
    if (data.estadoTrama === '0') {
      this.setState({ alertErrorMessage: data.mensaje });
      this.showAlert('alertErrorOpenModFacturacion');
    } else if (data.estadoTrama === '1') {
      this.setState({ alertSuccessMessage: data.mensaje });
      this.showAlert('alertErrorOpenModFacturacion');
    } else {
      this.setState({ alertErrorMessage: `Hubo un error con el servicio ${data.estadoTrama}` });
      this.showAlert('alertErrorOpenModFacturacion');
    }
  }

  showAlert = (alertType) => {
    this.setState({ [alertType]: true });
    setTimeout(() => this.setState({ [alertType]: false }), 5000);
  }

  fnSearchPedidos = () => {
    const { skuSap, codFamiliaVeh, numProfVeh ,numFichaVtaVeh } = this.props.proforma;
    this.props.searchPedidos(vacio, vacio, vacio, vacio, vacio, skuSap, codFamiliaVeh, numFichaVtaVeh, numProfVeh, nroPag, cantidadxPag)

  }

  fnNumPedidosProforma = () => {
      const { proforma } = this.props;
    this.setState({numPedidosProforma:this.props.pedidosProforma.filter(entry => entry[proforma.numProfVeh]!==undefined)[0][proforma.numProfVeh]})
  }


  waitForService = () => this.setState({ loading: true })
  afterService = () => this.setState({ loading: false })



  searchPedido = (pedido, nroPag ,cantxPag) => {

    const { skuSap, codFamiliaVeh, numProfVeh, numFichaVtaVeh } = this.props.proforma;
    this.waitForService();
    this.props.searchPedidos(vacio, pedido, vacio, vacio, vacio, skuSap, codFamiliaVeh, numFichaVtaVeh, numProfVeh, nroPag, cantxPag).then(result =>this.afterService());

  }

  nextStep = () => this.setState({ step: this.state.step + 1 })
  previousStep = () => this.setState({ step: this.state.step - 1 })

  saveStateAndNext = (step, state) => {

    this.setState({ [step]: { ...state } });
    this.nextStep();
  }



  backToStep1 = () => {

    this.setState({ SecondStep: { init: true } });
    this.previousStep();
  }

  closeModal=()=>{
    this.setState({pedidosSeleccionadosOld:[]})
    this.props.closeModal();
  }

  render() {
    const { step } = this.state;
    const { proforma, pedidos, fdv } = this.props;
    const stepsTitle = ['Elegir N° pedido', 'Datos del cliente', 'Confirmar'];



    return (
      <div>
        <Modal isOpen idModal='nueva-proforma' modalSize='modal-dialog modal-xlg'  title='Asociar pedido(s)' closeModal={this.closeModal}>
          <div className='modalBleed'>
            <Steps stepsTitle={stepsTitle} step={step} />
          </div>


          {
            step === 1 &&
              <FirstStep
                nextStep={this.saveStateAndNext}
                proforma={proforma}
                pedidos={pedidos}
                searchPedido={this.searchPedido}
                pedidosConCheck={this.props.pedidosConCheck}
                openAlertModal={this.props.openAlertModal}
                numPedidosProforma={this.state.numPedidosProforma}
                waitForService={this.waitForService}
                afterService={this.afterService}
                listProformaOrTabProforma={this.props.listProformaOrTabProforma}
                {...this.state.FirstStep}
                fnPedidosSeleccionadosOld={this.fnPedidosSeleccionadosOld}
                pedidosSeleccionadosOld={this.state.pedidosSeleccionadosOld}
              />
          }
          {
            step === 2 &&
              <SecondStep
                previousStep={this.backToStep1}
                nextStep={this.saveStateAndNext}
                {...this.state.FirstStep}
                {...this.state.SecondStep}
                clienteName={fdv.nomPerso}
                clienteId={fdv.codClie}
              />
          }
          {
            step === 3 &&
            <ThirdStep
              proforma={proforma}
              {...this.state.FirstStep}
              {...this.state.SecondStep}
              previousStep={this.previousStep}
              closeModal={this.closeModal}
              openAlert={this.props.openAlert}
              changeIndex={this.props.changeIndex}
              vendedor={this.props.fdv.vendedor}
              waitForService={this.waitForService}
              afterService={this.afterService}
              traerFacturacion={this.props.traerFacturacion}
              loadProformas={this.props.loadProformas}
              fdv={this.props.fdv}
              openAlertFacturacion={this.openAlertFacturacion}

            />
          }
        </Modal>
        {
          this.state.loading &&
            <Loader />
        }

        { this.state.alertErrorOpenModFacturacion &&
          <Alert type='alert-warning alertModal' icon='ion-alert-circled' closeAlert={this.closeAlertErrorModFacturacion}>
            <p>{this.state.alertErrorMessage}</p>
          </Alert>
        }

        {
          this.props.pedidosBuscar && this.props.pedidosBuscar.error ?
            <Alert type='alert-danger' icon='ion-alert-circled'>
              <p>Hubo un error con el servicio de listar pedidosBuscar</p>
            </Alert> : null
        }

      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    pedidos: state.pedidosBuscar,
  };
}

export default connect(mapStateToProps,
  { searchPedidos, clearPedidosBuscar })(AsociarPedido);



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/TabViews/Proformas/AsociarPedidos/index.js